import { createFromIconfontCN } from '@ant-design/icons';

export const WeatherIconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2422039_ygso8m7seu.js',
});
export const PokerIconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_2434404_bpzehbwmcy7.js',
});